var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"avatar",style:(_vm.size? ("width:" + (20) + "px !important;"):''),attrs:{"src":_vm.gender === 2 ?
(_vm.BaseUrl + "assets/common/gender_woman_l.png") :
(_vm.gender === 1 ?
(_vm.BaseUrl + "assets/common/gender_man_l.png") :
(_vm.BaseUrl + "assets/common/gender_unknow_l.png")),"srcset":_vm.gender === 2 ?
(_vm.BaseUrl + "assets/common/gender_woman_l@2x.png") :
(_vm.gender === 1 ?
(_vm.BaseUrl + "assets/common/gender_man_l@2x.png") :
(_vm.BaseUrl + "assets/common/gender_unknow_l@2x.png"))}})}
var staticRenderFns = []

export { render, staticRenderFns }